export type MedicalRecordReleaseStatusDescriptor = {
  name: string;
  value: number;
  description: string;
}

export class MedicalRecordReleaseConstants {
  /**********************************************************
   * If changes are made, API code must be updated to match *
   **********************************************************/

  /**********************************************************
   * If these constants are changed, be sure to check & test:
   * - the MedicalRecordReleaseIndexStore.sortIndex() function, as sorting depends on these values
   * - MedicalRecordReleaseIndexComponent, Elapsed Days table column, as it depends on MRR_PENDING
  **********************************************************/
  static readonly MRR_INITIATED: number = 2;  // Must match lookup value
  static readonly MRR_ACTIVE: number = 5;  // Must match lookup value
  static readonly MRR_PENDING: number[] = [1,2,3];  // Must match lookup value
  static readonly MRR_TERMINAL_STATES: number[] = [0,4,6,7,8];  // Must match lookup value

  // Sharee Roles
  static status: MedicalRecordReleaseStatusDescriptor[] = [
    { name: "Unknown", value: 0, description: "None or Unknown" },
    { name: "Created", value: 1, description: "Request entity has been created, but process has NOT been initiated by Health Record Owner"},
    { name: "Initiated", value: 2, description: "Initiated by Health Record Owner"},
    { name: "Under Review", value: 3, description: "Received by Clinic and is under review"},
    { name: "Cancelled", value: 4, description: "Cancelled by the Health Record Owner (before it was approved or denied by Clinic)"},
    { name: "Approved", value: 5, description: "Medical Record Release has been APPROVED by the Clinic"},
    { name: "Rejected", value: 6, description: "Request for Medical Record Release has been REJECTED by the Clinic"},
    { name: "Terminated", value: 7, description: "Medical Record Release has been TERMINATED by the Clinic"},
    { name: "Administratively Terminated", value: 8, description: "Medical Record Release has been ADMINISTRATIVELY TERMINATED by SurvivorLink"},
  ]


}
